import React from "react";
import { Link } from "react-scroll";

import "./NavLink.scss";

interface NavLinkProps {
  children: React.ReactNode;
  sectionID: string;
  offsetTopDesktop?: number;
  offsetTopMobile?: number;
  smooth?: boolean;
  duration?: number;
  className?: string;
  isMobile?: boolean;
  onClick?: () => void;
}

const NavLink = ({
  children,
  sectionID,
  offsetTopDesktop = -45,
  offsetTopMobile = 0,
  smooth = true,
  duration = 250,
  className,
  isMobile = false,
  onClick
}: NavLinkProps) => {
  const offsetTop = isMobile ? offsetTopMobile : offsetTopDesktop;

  const navbarLinkClass = `nav-link`;
  const navbarLinkActiveClass = `nav-active-link`;

  return (
    <Link
      to={sectionID}
      offset={offsetTop}
      smooth={smooth}
      duration={duration}
      className={`${navbarLinkClass} ${className}`}
      activeClass={navbarLinkActiveClass}
      onClick={onClick}
      spy
    >
      {children}
    </Link>
  );
};

export default NavLink;
